// extracted by mini-css-extract-plugin
export default {"tabTitleWithErrorCount":"tab-title-with-error-count__tab-title-with-error-count__PMlCZ","errorCount":"tab-title-with-error-count__error-count__pMTH8"};